module.exports = __webpack_public_path__ + "img/filter-price.b095e0de.svg";